import { createFileRoute } from '@tanstack/react-router';
import { CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/a/doc-errors')({
  component: Component,
});

function Component() {
  // const { data, error, isError, isPending } = useQuery(api.docMigrations.list);
  //
  // if (isPending) return <LoadingIcon />;
  // if (isError) {
  //   return <ErrorAlert message={error.message} title="Error loading doc validations" />;
  // }
  // const docValidations: DocMigrationCvx[] = data;

  return (
    <div>
      <CardTitle>Doc Errors</CardTitle>
    </div>
  );
}
